import { render, staticRenderFns } from "./ObjectActions.vue?vue&type=template&id=4ec5e19a&scoped=true&"
import script from "./ObjectActions.vue?vue&type=script&lang=js&"
export * from "./ObjectActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec5e19a",
  null
  
)

export default component.exports